export default __webpack_public_path__ + "static/media/rajaram.63a8e03b.jpg";